import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { ROUTES } from 'configs/routes';
import { useDetailHeight } from 'hooks/useDetailHeight';
import { useHeaderVisibility } from 'hooks/useHeaderVisibility';
import { useRootStore } from 'stores/global/RootStore/context';

type LkLayoutConfig = {
  isProfilePage: boolean;
  shouldShowHeader: boolean;
  shouldUseDetailHeight: boolean;
  withHeaderBottomPadding: boolean;
  shouldShowAccreditationBanner: boolean;
};

export const useLkLayoutConfig = (): LkLayoutConfig => {
  const location = useLocation();
  const shouldShowHeader = useHeaderVisibility();
  const shouldUseDetailHeight = useDetailHeight();

  const hasAccreditation = useRootStore().userStore.hasAccreditation;

  return useMemo(() => {
    const profilePagePath = ROUTES.lk.profile.path;
    const lotsPagePath = ROUTES.lk.lots.path;

    const isProfilePage = location.pathname === profilePagePath || location.pathname.startsWith(`${profilePagePath}/`);
    const isLotsPage = location.pathname === lotsPagePath || location.pathname.startsWith(`${lotsPagePath}/`);
    // индекс /lk сам редиректит по роли/аккредитации (LkIndexRedirect) — не подменяем его заглушкой
    const isLkIndexPage = location.pathname === ROUTES.lk.path;

    // показывается баннер при отсутствии аккредитации
    const shouldShowAccreditationBanner = !isProfilePage && !isLotsPage && !isLkIndexPage && !hasAccreditation;

    return {
      isProfilePage,
      shouldShowHeader,
      shouldUseDetailHeight,
      shouldShowAccreditationBanner,

      withHeaderBottomPadding: !isProfilePage && !shouldShowAccreditationBanner,
    };
  }, [location.pathname, shouldShowHeader, shouldUseDetailHeight, hasAccreditation]);
};
